import React from 'react';
import { connect } from 'dva';
import ChildCard from '../ChildCard/ChildCard';
import { getNotHiddenChildren } from '../../../selectors/children';
import { createStructuredSelector } from 'reselect';

function ChildCardList({ children }) {
  if (!children.length) return null;
  return (
    <div className="ChildCardList">
      {children.map(({ id }) => (
        <ChildCard key={id} id={id} />
      ))}
    </div>
  );
}

export default connect(
  createStructuredSelector({ children: getNotHiddenChildren })
)(ChildCardList);
